<script lang="ts">
  import ApplyContact from "./ApplyContact.svelte";
</script>

<div class="section-content">
  <h1 class="section-title mb-6">How To Apply ?</h1>

  <div class="section-description mb-6">
    If this sounds like a cool project and you’re interested in applying to one
    or more of the above roles, please send your resume or open source profile
    to my email and we’ll get back to you.
  </div>

  <ApplyContact />
</div>

<style lang="postcss">
  .section-content {
    padding: 64px 0px 96px;
  }
</style>
